
// SVG Icon: compare-left-panel
export default { id: "terriajs-compare-left-panel" };
export const id = "terriajs-compare-left-panel";
export const name = "compare-left-panel";
